import T from "../i18n/Text";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Tooltip } from "antd";

interface Props {
    children: any;
    labelPath?: string;
    label?: string;
    infoPath?: string;
    info?: any;
}

const ConfigInputContainer = ({
    children,
    labelPath,
    label,
    infoPath,
    info,
}: Props) => {
    const [iconStyle, setIconStyle] = useState({
        color: "rgba(141, 141, 141, 0.3)",
    });

    const handleMouseEnter = () => {
        setIconStyle({ color: "#8D8D8D" });
    };

    const handleMouseLeave = () => {
        setIconStyle({ color: "rgba(141, 141, 141, 0.3)" });
    };
    const labelText = !!label ? (
        label
    ) : !!labelPath ? (
        <T path={labelPath} />
    ) : (
        labelPath
    );
    const additionalInfo = info ? info : (infoPath ? <T path={infoPath} /> : null);
    const labelElement = !!labelText ? (
        <p className="mb-0 text-[20px]">{labelText}</p>
    ) : null;
    return (
        <div className="relative flex items-baseline  w-full  md:w-[474px] ">
            <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="flex relative justify-between w-full  md:w-[474px] items-center bg-[#DFD2CC] pt-[9px] pb-[9px] pl-[20px] pr-[23px] mb-5 rounded mr-1">
                {labelElement}
                {children}
            </div>
            {additionalInfo && (
                <Tooltip
                    className="max-sm:hidden sm:hidden md:flex md:absolute -right-[23px] top-50% translate-y-[90%] "
                    placement="topRight"
                    arrow={false}
                    title={additionalInfo}>
                    <InfoCircleOutlined
                        style={iconStyle}
                        className="info-hover"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default ConfigInputContainer;
